module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAALBAMAAACufOGlAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURb+/v7+/v0dwTMDAwL+/v7+/v8DAwMDAwMDAwOQZAxcAAAAIdFJOU5wQANBgMPCw4XNQKgAAADRJREFUCNdjcFFSYuBwUmJQaFFiUOJwYlBSaGFQUm1mUAozZFBNFmIIM1RiKBZSYhBUUgIAkgcGn1Rz57UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/rightArrow.png
// module id = 1781
// module chunks = 5